import { Permission } from '@Constants/Permission.g';
import { useHasPermission } from '@Contexts/appContext';
import { usePrintOptions } from '@Hooks/Documents';
import { isNullOrEmpty } from '@synqo/frontend-component-library';

/**
 * The print options of a requisition: the documents of the orders placed for it. Named here rather
 * than at each call site so the operator's and the customer's view of a requisition always offer the
 * same documents.
 *
 * The print menu is optional for a customer — an operator can withhold the permission — so it is only
 * asked for when the session may read documents at all.
 */
export function useRequisitionPrintOptions(requisitionId: string) {
    const hasPermission = useHasPermission();

    const isEnabled = !isNullOrEmpty(requisitionId) && hasPermission(Permission.DocumentsDocumentRead);

    return usePrintOptions('requisition', requisitionId, isEnabled);
}
